import DateFnsUtils from "@date-io/date-fns";
import { Backdrop, CircularProgress, withStyles } from "@material-ui/core";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import {
  Alert,
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  TableCell,
} from "@mui/material";

import { format } from "date-fns";
import React, { Component, forwardRef } from "react";
import Button from "../../components/Custom/Button/Button";
import SearchIcon from "@material-ui/icons/Search";
import MaterialTable from "../../components/MaterialTable";
import TableIcons from "../common/TableLogoComponent";
import AddBox from "@material-ui/icons/AddBox";
import ApiService from "../../ApiService";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import XlsIcon from "./XlsIcon";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
  },
}))(TableCell);

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  detailhead: {
    fontSize: 12,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#ffffff",
  },
  searchbar: {
    margin: theme.spacing(2),
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: "absolute",
    marginTop: 8,
    marginLeft: -65,
  },
  formControl: {
    minWidth: 200,
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
      marginBottom: theme.spacing(2),
    },
  },
});

class RollingReserveSettlement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failed: false,
      success: false,
      responsemessage: null,
      fromDate: null,
      toDate: null,
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      fromTimeStr: "00:00:00",
      toTimeStr: "23:59:59",
      tableData: [],
      tableData2: [],

      showTableData: false,
      showTableData2: false,
      addChargeDialogOpen: false,
      merchantTerminals: [],
      masterCharges: [],
      selectedTerminal: null,
      selectedCharge: "",
      chargeDescription: "",
      chargeCurrency: "",
      chargeValue: "",
      validFrom: new Date(),
      validTo: new Date(),
      formError: {
        selectedCharge: false,
        chargeDescription: false,
        chargeCurrency: false,
        chargeValue: false,
      },
      selectedRows: [],
      exchangeRates: [],
      fromCurrency: null,
      toCurrency: null,
      exchangeRatePanelVisible: false,
      progressOpen: false,
      merchants: [],
      selectedMerchant: null,
      label: [],
    };
  }

  fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  };

  handleMerchantChange = (event, newValue) => {
    const selectedMer = newValue ? newValue.id : null;
    if (selectedMer) {
      this.setState({ selectedMerchant: selectedMer });
      this.showTerminalsById(selectedMer);
    } else {
      this.setState({
        selectedMerchant: null,
        merchantTerminals: [],
        selectedTerminal: null,
        tableData: [],
        tableData2: [],
        showTableData: false,
        showTableData2: false,
      });
      this.fetchMerchantTerminals();
    }
  };

  showTerminalsById = (merchantId) => {
    if (merchantId || merchantId !== null) {
      ApiService.fetchMerchantTerminalsByMerId(merchantId)
        .then((res) => {
          this.setState({ merchantTerminals: res.data });
        })
        .catch((e) => {});
    }
  };

  markRrWireSettled = (wireId) => {
    this.setState({ progressOpen: true });
    ApiService.settleRrWire(wireId)
      .then((res) => {
        this.fetchRrWires();
        if (res.data.status === "OK") {
          this.setState({
            progressOpen: false,
            success: true,
            failed: false,
            responsemessage: "Released",
          });
        } else {
          this.setState({
            progressOpen: false,
            failed: true,
            success: false,
            responsemessage: res.data.responseMessage,
          });
        }
      })
      .catch((e) => {
        this.setState({
          progressOpen: false,
          failed: true,
          responsemessage: e,
        });
      });
  };

  showPdf = (wireId) => {
    ApiService.fetchRrWirePdf(wireId);
  };
  showXLS = (wireId) => {
    ApiService.fetchRrWireXls(wireId);
  };
  deleteRrWire(wireId) {
    ApiService.deleteRrWire(wireId).then((res) => {
      if (res.data.status === "OK") {
        this.setState({
          progressOpen: false,
          success: true,
          failed: false,
          responsemessage: "Deleted",
        });
        this.fetchRrWires();
      } else {
        this.setState({
          progressOpen: false,
          failed: true,
          success: false,
          responsemessage: res.data.responseMessage,
        });
      }
    });
  }

  deleteRrCharge = (data) => {
    const chargeId = data.map((d) => +d.id)[0];
    ApiService.deleteRrCharge(chargeId)
      .then((res) => {
        if (res.data.status === "OK") {
          this.setState({
            progressOpen: false,
            success: true,
            failed: false,
            responsemessage: "Charge Deleted",
          });
          this.handleSearch();
        } else {
          this.setState({
            progressOpen: false,
            failed: true,
            success: false,
            responsemessage: res.data.responseMessage,
          });
        }
      })
      .catch((e) => {
        this.setState({
          progressOpen: false,
          failed: true,
          success: false,
          responsemessage: e,
        });
      });
  };

  handleShowAddChargePanel = () => {
    this.setState({ addChargeDialogOpen: true });
    this.fetchMasterCharges();
  };
  fetchMasterCharges = () => {
    ApiService.fetchMasterCharges().then((res) => {
      this.setState({ masterCharges: res.data });
    });
  };
  hideExchangeRatesPanel = () => {
    this.setState({ exchangeRatePanelVisible: false });
  };

  componentDidMount() {
    this.fetchMerchantTerminals();
    this.fetchAllMerchants();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.success && prevState.success !== this.state.success) {
      this.clearMessage();
    }
    if (this.state.failed && prevState.failed !== this.state.failed) {
      this.clearMessage();
    }
  }

  clearMessage = () => {
    setTimeout(() => {
      this.setState({
        success: false,
        failed: false,
        responsemessage: null,
      });
    }, 3000);
  };

  fetchExchangeRatesForWire = () => {
    if (this.state.selectedTerminal.terminalId === null) {
      this.setState({
        failed: true,
        responsemessage: "Please select Terminal to Create Wire.",
      });
    } else {
      ApiService.fetchExchangeRatesForWire(
        this.state.selectedTerminal.terminalId
      ).then((res) => {
        if (res.data === undefined || res.data.length === 0) {
          this.generateRrWire();
        } else {
          this.setState({
            exchangeRates: res.data,
            fromCurrency: res.data[0].fromCurrency,
            toCurrency: res.data[0].toCurrency,
            exchangeRatePanelVisible: true,
            failed: false,
            responsemessage: null,
          });
        }
      });
    }
  };

  generateRrWire = () => {
    this.setState({
      terminalId: this.state.selectedTerminal.terminalId,
    });
    this.state.terminalId = this.state.selectedTerminal.terminalId;

    const adjustedRates = this.state.exchangeRates.map((rate) => {
      if (rate.fromCurrency === rate.toCurrency) {
        return { ...rate, exchangeRate: 1 };
      }
      return rate;
    });

    var reqForm = {
      enitityId: this.state.selectedTerminal.terminalId,
      validFrom:
        format(this.state.fromDate, "yyyyMMdd") + " " + this.state.fromTimeStr,
      validTo:
        format(this.state.toDate, "yyyyMMdd") + " " + this.state.toTimeStr,
      exchangeRates: adjustedRates,
    };

    var request = Object.assign({}, reqForm);
    ApiService.createRollingReserveWire(request).then((res) => {
      this.setState({
        progressOpen: true,
      });
      if (res.data.status === "OK") {
        this.setState({
          exchangeRatePanelVisible: false,
          failed: false,
          success: true,
          progressOpen: false,
          responsemessage: res.data.responseMessage,
        });
        this.fetchRrWires();
      } else {
        this.setState({
          responsemessage: res.data.responseMessage,
          exchangeRatePanelVisible: false,
          success: false,
          failed: true,
          progressOpen: false,
        });
      }
    });
  };

  fetchRrWires = () => {
    var reqForm = {
      validFrom:
        format(this.state.fromDate, "yyyyMMdd") + " " + this.state.fromTimeStr,
      validTo:
        format(this.state.toDate, "yyyyMMdd") + " " + this.state.toTimeStr,

      terminalId: this.state.selectedTerminal.terminalId,
    };
    var request = Object.assign({}, reqForm);
    ApiService.fetchRrWires(request).then((res) => {
      this.setState({ tableData2: res.data.responseEntity });
    });
  };

  fetchMerchantTerminals = () => {
    ApiService.fetchMerchantTerminals().then((res) => {
      this.setState({ merchantTerminals: res.data });
    });
  };

  handleDialogClose = () => {
    this.setState({
      addChargeDialogOpen: false,
      selectedCharge: "",
      chargeDescription: "",
      chargeCurrency: "",
      chargeValue: "",
      validFrom: new Date(),
      validTo: new Date(),
    });
  };

  validateForm = () => {
    const error = {
      selectedCharge: this.state.selectedCharge === "",
      chargeDescription: this.state.chargeDescription === "",
      chargeCurrency: this.state.chargeCurrency === "",
      chargeValue: this.state.chargeValue === "",
    };
    return Object.values(error).every((x) => !x);
  };

  handleApply = () => {
    if (this.validateForm()) {
      const formErrors = {
        selectedCharge: this.state.selectedCharge === "",
        chargeDescription: this.state.chargeDescription === "",
        chargeCurrency: this.state.chargeCurrency === "",
        chargeValue: this.state.chargeValue === "",
      };
      this.setState({ formError: formErrors });

      var reqForm = {
        chargeValidFrom: format(this.state.fromDate, "yyyyMMdd"),
        chargeValidTo: format(this.state.toDate, "yyyyMMdd"),
        chargeDescription: this.state.chargeDescription,
        chargeCurrency: this.state.chargeCurrency,
        chargeValue: this.state.chargeValue,

        terminalId: this.state.selectedTerminal.terminalId,
        chargeId: this.state.selectedCharge,
      };
      var request = Object.assign({}, reqForm);
      ApiService.addRrWireCharge(request)
        .then((res) => {
          if (res.data.status === "OK") {
            this.setState({
              addChargeDialogOpen: false,
              success: true,
              failed: false,
              responsemessage: "Charge added successfully",
              selectedCharge: "",
              chargeDescription: "",
              chargeCurrency: "",
              chargeValue: "",
              validFrom: new Date(),
              validTo: new Date(),
            });
            this.handleSearch();
          } else {
            this.setState({
              addChargeDialogOpen: false,
              success: false,
              failed: true,
              responsemessage: "Failed to add charge. Please try again",
              selectedCharge: "",
              chargeDescription: "",
              chargeCurrency: "",
              chargeValue: "",
              validFrom: new Date(),
              validTo: new Date(),
            });
          }
        })
        .catch((err) => {
          this.setState({
            addChargeDialogOpen: false,
            success: false,
            failed: true,
            responsemessage: "Failed to add charge. Please try again",
            selectedCharge: "",
            chargeDescription: "",
            chargeCurrency: "",
            chargeValue: "",
            validFrom: new Date(),
            validTo: new Date(),
          });
        });
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSelectTerminal = (event, newValue) => {
    if (newValue && typeof newValue === "object") {
      const terminal = newValue;
      this.setState({ selectedTerminal: terminal });
    } else {
      this.setState({
        selectedTerminal: null,
        tableData: [],
        tableData2: [],
        showTableData: false,
        showTableData2: false,
      });
    }
  };

  handleSearch = () => {
    if (
      this.state.selectedTerminal === null ||
      this.state.fromDate === null ||
      this.state.toDate === null
    ) {
      this.setState({
        failed: true,
        success: false,
        responsemessage: "Please select all the fields",
      });
    } else {
      var reqForm = {
        validFrom:
          format(this.state.fromDate, "yyyyMMdd") +
          " " +
          this.state.fromTimeStr,
        validTo:
          format(this.state.toDate, "yyyyMMdd") + " " + this.state.toTimeStr,

        terminalId: this.state.selectedTerminal.terminalId,
      };
      var request = Object.assign({}, reqForm);
      ApiService.fetchRollingReserveCharge(request)
        .then((res) => {
          if (res.data.status === "OK") {
            this.setState({
              tableData: res.data.responseEntity,
              success: true,
              failed: false,
              showTableData: true,
              showTableData2: true,
              responsemessage: res.data.responseMessage,
            });
            this.fetchRrWires();
          } else {
            this.setState({
              tableData: [],
              success: false,
              failed: true,
              showTableData: false,
              showTableData2: false,
              responsemessage: res.data.responseMessage,
            });
          }
        })
        .catch((err) => {
          this.setState({
            tableData: [],
            success: false,
            failed: true,
            showTableData: false,
            showTableData2: false,
            responsemessage: "Failed to fetch charges. Please try again",
          });
        });
    }
  };

  tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  render() {
    const { classes } = this.props;
    const { merchantTerminals } = this.state;
    return (
      <>
        <Paper style={{ margin: "1em", padding: "1em" }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Rolling Reserve Settlement
          </Typography>
          <Divider light className={classes.searchbar} />
          {this.state.failed && (
            <Alert severity="error" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          &nbsp;
          <Box sx={{ display: "flex", justifyContent: "left", gap: "1em" }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                autoOk
                label="Settlement From"
                format="MM/dd/yyyy"
                value={this.state.fromDate}
                onChange={(date) => this.setState({ fromDate: date })}
                style={{ width: 180 }}
              />
              &nbsp;&nbsp;
              <TimePicker
                label="From Time"
                views={["hours", "minutes", "seconds"]}
                value={this.state.fromTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    fromTime: val,
                    fromTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ width: 120 }}
              />
              &nbsp;&nbsp;
              <DatePicker
                autoOk
                label="Settlement To"
                format="MM/dd/yyyy"
                value={this.state.toDate}
                onChange={(date) => this.setState({ toDate: date })}
                style={{ width: 160 }}
              />
              &nbsp;&nbsp;
              <TimePicker
                label="To Time"
                className="timePicker"
                views={["hours", "minutes", "seconds"]}
                value={this.state.toTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    toTime: val,
                    toTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ width: 120 }}
              />
              &nbsp;&nbsp;
            </MuiPickersUtilsProvider>
            <FormControl style={{ minWidth: 200 }}>
              <Autocomplete
                options={this.state.merchants}
                getOptionLabel={(option) =>
                  option ? option.merchantName + "-" + option.code : ""
                }
                value={
                  this.state.merchants.find(
                    (merchant) => merchant.id === this.state.selectedMerchant
                  ) || null
                }
                onChange={this.handleMerchantChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Merchants"
                    fullWidth
                    variant="standard"
                    size="small"
                  />
                )}
              />
            </FormControl>
            &nbsp;&nbsp;
            <FormControl style={{ minWidth: 200 }}>
              <Autocomplete
                options={merchantTerminals}
                value={this.state.selectedTerminal}
                onChange={this.handleSelectTerminal}
                getOptionLabel={(option) =>
                  option ? option.label + "-" + option.terminalCardType : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Terminal"
                    size="small"
                    variant="standard"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SearchIcon />}
              sx={{ mt: 5, mr: 4 }}
              onClick={this.handleSearch}
            >
              Search
            </Button>
            <Backdrop
              open={this.state.progressOpen}
              className={classes.backdrop}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
          {this.state.showTableData && (
            <MaterialTable
              style={{ margin: "2em 0 0 0" }}
              title="Configured Charges"
              icons={TableIcons.icons}
              columns={[
                { field: "charge.name", title: "NAME" },
                { field: "chargeValue", title: "VALUE" },
                { field: "charge.type", title: "TYPE" },
                { field: "charge.direction", title: "DIRECTION" },
                { field: "charge.frequency", title: "FREQUENCY" },

                {
                  field: "validFrom",
                  title: "FROM",
                  render: (rowData) => (
                    <Typography noWrap="true" variant="caption">
                      {format(new Date(rowData.validFrom), "dd MMM yyyy")}
                    </Typography>
                  ),
                },
                {
                  field: "validTo",
                  title: "TO",
                  render: (rowData) => (
                    <Typography noWrap="true" variant="caption">
                      {format(new Date(rowData.validTo), "dd MMM yyyy")}
                    </Typography>
                  ),
                },
                { field: "chargeCurrency", title: "CURRENCY" },
              ]}
              data={this.state.tableData}
              actions={[
                {
                  icon: (props) => (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.button}
                      startIcon={<AddBox />}
                    >
                      Wire
                    </Button>
                  ),
                  tooltip: "Create Wire",
                  isFreeAction: true,
                  onClick: (event) => this.fetchExchangeRatesForWire(),
                },
                {
                  icon: (props) => (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.button}
                      startIcon={<AddBox />}
                    >
                      Charge
                    </Button>
                  ),
                  tooltip: "Add Charge",
                  isFreeAction: true,
                  onClick: (event) => this.handleShowAddChargePanel(),
                },

                {
                  tooltip: "Delete selected charge",
                  icon: (props) => (
                    <DeleteIcon
                      {...props}
                      color={
                        this.state.selectedRows.length !== 1
                          ? "disabled"
                          : "primary"
                      }
                    />
                  ),

                  onClick: (evt, data) => {
                    if (this.state.selectedRows.length === 1) {
                      this.deleteRrCharge(data);
                    }
                  },
                  disabled: this.state.selectedRows.length !== 1,
                },
              ]}
              onSelectionChange={(selectedRows) => {
                this.setState({ selectedRows });
              }}
              options={{
                search: false,
                exportButton: false,
                pageSize: 20,
                pageSizeOptions: [20, 50, 100],
                padding: "default",
                showEmptyDataSourceMessage: true,
                selection: true,
                actionsColumnIndex: -1,
                tableLayout: "auto",
                emptyRowsWhenPaging: false,
              }}
            />
          )}
          {this.state.showTableData2 && (
            <MaterialTable
              style={{ margin: "2em 0 0 0" }}
              title="Rolling Reserve"
              icons={TableIcons.icons}
              columns={[
                {
                  field: "rrAmount",
                  title: "RR AMOUNT",
                  render: (rowData) => (
                    <Typography variant="inherit">
                      {rowData.rrAmount && rowData.rrAmount.toFixed(2)}
                    </Typography>
                  ),
                },
                { field: "processingCurrency", title: "PROCESSING CURRENCY" },
                { field: "settlementCurrency", title: "SETTLEMENT CURRENCY" },

                {
                  field: "rrSettled",
                  title: "RELEASED",
                  render: (rowData) => (rowData.rrSettled ? "Yes" : "No"),
                },

                {
                  field: "validFrom",
                  title: "FROM",
                  render: (rowData) => (
                    <Typography noWrap="true" variant="caption">
                      {format(new Date(rowData.validFrom), "dd MMM yyyy")}
                    </Typography>
                  ),
                },
                {
                  field: "validTo",
                  title: "TO",
                  render: (rowData) => (
                    <Typography noWrap="true" variant="caption">
                      {format(new Date(rowData.validTo), "dd MMM yyyy")}
                    </Typography>
                  ),
                },
              ]}
              data={this.state.tableData2}
              actions={[
                (rowData) => ({
                  tooltip: "Delete",
                  icon: (props) => (
                    <DeleteForeverIcon
                      {...props}
                      color={
                        rowData.rrSettled === true ? "disabled" : "primary"
                      }
                    />
                  ),
                  onClick: (evt, rowData) => {
                    if (rowData.rrSettled === false) {
                      this.deleteRrWire(rowData.wireId);
                    }
                  },
                }),
                (rowData) => ({
                  tooltip: "Mark as Released",
                  icon: (props) => (
                    <HandshakeIcon
                      {...props}
                      color={
                        rowData.rrSettled === true ? "disabled" : "primary"
                      }
                    />
                  ),

                  onClick: (evt, rowData) => {
                    if (rowData.rrSettled === false) {
                      this.markRrWireSettled(rowData.wireId);
                    }
                  },
                }),
                {
                  tooltip: "Generate PDF",
                  icon: (props) => (
                    <PictureAsPdfIcon {...props} color="primary" />
                  ),
                  onClick: (evt, rowData) => this.showPdf(rowData.wireId),
                },

                {
                  tooltip: "Download Transaction XLS",
                  icon: (props) => (
                    <XlsIcon color="primary" fontSize="medium" />
                  ),

                  onClick: (evt, rowData) => this.showXLS(rowData.wireId),
                },
              ]}
              options={{
                search: false,
                exportButton: false,
                pageSize: 20,
                pageSizeOptions: [20, 50, 100],
                padding: "default",
                showEmptyDataSourceMessage: true,
                selection: false,
                actionsColumnIndex: -1,
                tableLayout: "auto",
                emptyRowsWhenPaging: false,
              }}
            />
          )}
          <Dialog
            open={this.state.addChargeDialogOpen}
            onClose={this.handleDialogClose}
          >
            <DialogTitle>ADD CHARGE</DialogTitle>
            <DialogContent>
              <FormControl
                error={this.state.formError.selectedCharge}
                style={{ minWidth: 200, marginTop: 10 }}
                fullWidth
              >
                <InputLabel id="selectChargeLabel">Select Charge</InputLabel>
                <Select
                  name="selectedCharge"
                  value={this.state.selectedCharge}
                  onChange={this.handleChange}
                  label="Select Charge"
                >
                  {this.state.masterCharges.map((ac) => (
                    <MenuItem key={ac.id} value={ac.id} dense>
                      {ac.name +
                        "-" +
                        ac.type +
                        "-" +
                        ac.direction +
                        "-" +
                        ac.frequency}
                    </MenuItem>
                  ))}
                </Select>
                {this.state.formError.selectedCharge && (
                  <FormHelperText>Please select a charge</FormHelperText>
                )}
              </FormControl>

              <TextField
                margin="dense"
                fullWidth
                label="Charge Description"
                type="text"
                name="chargeDescription"
                value={this.state.chargeDescription}
                onChange={this.handleChange}
                error={this.state.formError.chargeDescription}
                helperText={
                  this.state.formError.chargeDescription &&
                  "Please enter a description"
                }
              />
              <TextField
                margin="dense"
                fullWidth
                label="Charge Currency"
                type="text"
                name="chargeCurrency"
                value={this.state.chargeCurrency}
                onChange={this.handleChange}
                error={this.state.formError.chargeCurrency}
                helperText={
                  this.state.formError.chargeCurrency &&
                  "Please enter a currency"
                }
              />
              <TextField
                margin="dense"
                fullWidth
                label="Charge Value"
                type="number"
                name="chargeValue"
                value={this.state.chargeValue}
                onChange={this.handleChange}
                error={this.state.formError.chargeValue}
                helperText={
                  this.state.formError.chargeValue && "Please enter a value"
                }
              />
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Box display="flex" justifyContent="space-around" mt={2}>
                  <Box mr={2}>
                    <DatePicker
                      autoOk
                      label="Valid From"
                      format="MM/dd/yyyy"
                      value={this.state.fromDate}
                      onChange={(date) => this.setState({ fromDate: date })}
                      disabled={true}
                    />
                  </Box>
                  <Box>
                    <DatePicker
                      autoOk
                      label="Valid To"
                      format="MM/dd/yyyy"
                      value={this.state.toDate}
                      onChange={(date) => this.setState({ toDate: date })}
                      disabled={true}
                    />
                  </Box>
                </Box>
              </MuiPickersUtilsProvider>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleApply}
                color="primary"
                variant="contained"
                size="small"
                disabled={!this.validateForm()}
              >
                Apply
              </Button>
              <Button
                onClick={this.handleDialogClose}
                color="secondary"
                variant="outlined"
                size="small"
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.exchangeRatePanelVisible}
            onClose={this.hideExchangeRatesPanel}
          >
            <DialogContent>
              <MaterialTable
                style={{ margin: "2em 0 0 0" }}
                title="Define Exchange rates"
                icons={this.tableIcons}
                columns={[
                  {
                    field: "fromCurrency",
                    title: "From currency",
                    editable: "never",
                  },
                  {
                    field: "toCurrency",
                    title: "To currency",
                    editable: "never",
                  },

                  {
                    field: "exchangeRate",
                    type: "numeric",
                    title: "Exchange rate",
                    editable: (rowData) =>
                      rowData.fromCurrency !== rowData.toCurrency
                        ? "always"
                        : "never",

                    cellStyle: (rowData) => ({
                      backgroundColor:
                        rowData && rowData.fromCurrency === rowData.toCurrency
                          ? "#f5f5f5"
                          : "inherit",
                    }),
                    render: (rowData) =>
                      rowData && rowData.fromCurrency === rowData.toCurrency
                        ? "1"
                        : rowData.exchangeRate,
                  },
                ]}
                data={this.state.exchangeRates}
                editable={{
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        const dataUpdate = [...this.state.exchangeRates];
                        const index = oldData.tableData.id;
                        if (newData.fromCurrency === newData.toCurrency) {
                          newData.exchangeRate = 1;
                        }
                        dataUpdate[index] = newData;
                        this.setState({ exchangeRates: dataUpdate });
                        resolve();
                      }, 1000);
                    }),
                }}
                actions={[
                  {
                    icon: (props) => (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.button}
                        startIcon={<AddBox />}
                      >
                        Proceed
                      </Button>
                    ),
                    tooltip: "Create Wire",
                    isFreeAction: true,
                    onClick: (event) => this.generateRrWire(),
                  },
                ]}
                options={{
                  search: false,
                  exportButton: false,
                  padding: "default",
                  showEmptyDataSourceMessage: true,
                  selection: false,
                  actionsColumnIndex: -1,
                  tableLayout: "auto",
                  emptyRowsWhenPaging: false,
                }}
              />
            </DialogContent>
          </Dialog>
        </Paper>
      </>
    );
  }
}

export default withStyles(useStyles)(RollingReserveSettlement);
